import { render } from "./PercentageCircle.vue?vue&type=template&id=3d13f35a&scoped=true"
import script from "./PercentageCircle.vue?vue&type=script&lang=js"
export * from "./PercentageCircle.vue?vue&type=script&lang=js"

import "./PercentageCircle.vue?vue&type=style&index=0&id=3d13f35a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d13f35a"]])

export default __exports__